import { CALL_API, CONTENT_TYPE } from 'middlewares/api';
import { buildPageMeta } from 'containers/App/screens/Tube/utils';
import { url } from 'configs/';
import fetchData from 'utils/api';

const { NEWTUBE_API_SERVER } = url;

const FETCH_MANAGEMENT_TREEVIEWS_REQUEST =
  'tube/companyrules/management/FETCH_MANAGEMENT_TREEVIEWS_REQUEST';
const FETCH_MANAGEMENT_TREEVIEWS_SUCCESS =
  'tube/companyrules/management/FETCH_MANAGEMENT_TREEVIEWS_SUCCESS';
const FETCH_MANAGEMENT_TREEVIEWS_FAILURE =
  'tube/companyrules/management/FETCH_MANAGEMENT_TREEVIEWS_FAILURE';
const FETCH_MANAGEMENT_VIEW_REQUEST =
  'tube/companyrules/management/FETCH_MANAGEMENT_VIEW_REQUEST';
const FETCH_MANAGEMENT_VIEW_SUCCESS =
  'tube/companyrules/management/FETCH_MANAGEMENT_VIEW_SUCCESS';
const FETCH_MANAGEMENT_VIEW_FAILURE =
  'tube/companyrules/management/FETCH_MANAGEMENT_VIEW_FAILURE';
const DELETE_MANAGEMENT_NEWSFILE_REQUEST =
  'tube/companyrules/management/DELETE_MANAGEMENT_NEWSFILE_REQUEST';
const DELETE_MANAGEMENT_NEWSFILE_SUCCESS =
  'tube/companyrules/management/DELETE_MANAGEMENT_NEWSFILE_SUCCESS';
const DELETE_MANAGEMENT_NEWSFILE_FAILURE =
  'tube/companyrules/management/DELETE_MANAGEMENT_NEWSFILE_FAILURE';
const POST_MANAGEMENT_RULES_REQUEST =
  'tube/companyrules/management/POST_MANAGEMENT_RULES_REQUEST';
const POST_MANAGEMENT_RULES_SUCCESS =
  'tube/companyrules/management/POST_MANAGEMENT_RULES_SUCCESS';
const POST_MANAGEMENT_RULES_FAILURE =
  'tube/companyrules/management/POST_MANAGEMENT_RULES_FAILURE';
const PUT_MANAGEMENT_RULES_REQUEST =
  'tube/companyrules/management/PUT_MANAGEMENT_RULES_REQUEST';
const PUT_MANAGEMENT_RULES_SUCCESS =
  'tube/companyrules/management/PUT_MANAGEMENT_RULES_SUCCESS';
const PUT_MANAGEMENT_RULES_FAILURE =
  'tube/companyrules/management/PUT_MANAGEMENT_RULES_FAILURE';
const DELETE_MANAGEMENT_RULES_REQUEST =
  'tube/companyrules/management/DELETE_MANAGEMENT_RULES_REQUEST';
const DELETE_MANAGEMENT_RULES_SUCCESS =
  'tube/companyrules/management/DELETE_MANAGEMENT_RULES_SUCCESS';
const DELETE_MANAGEMENT_RULES_FAILURE =
  'tube/companyrules/management/DELETE_MANAGEMENT_RULES_FAILURE';
const POST_MANAGEMENT_CATEGORY_REQUEST =
  'tube/companyrules/management/POST_MANAGEMENT_CATEGORY_REQUEST';
const POST_MANAGEMENT_CATEGORY_SUCCESS =
  'tube/companyrules/management/POST_MANAGEMENT_CATEGORY_SUCCESS';
const POST_MANAGEMENT_CATEGORY_FAILURE =
  'tube/companyrules/management/POST_MANAGEMENT_CATEGORY_FAILURE';
const PUT_MANAGEMENT_CATEGORY_REQUEST =
  'tube/companyrules/management/PUT_MANAGEMENT_CATEGORY_REQUEST';
const PUT_MANAGEMENT_CATEGORY_SUCCESS =
  'tube/companyrules/management/PUT_MANAGEMENT_CATEGORY_SUCCESS';
const PUT_MANAGEMENT_CATEGORY_FAILURE =
  'tube/companyrules/management/PUT_MANAGEMENT_CATEGORY_FAILURE';
const PUT_VALIDATE_CORPORATION_PERMISSION_REQUEST =
  'tube/companyrules/management/PUT_VALIDATE_CORPORATION_PERMISSION_REQUEST';
const PUT_VALIDATE_CORPORATION_PERMISSION_SUCCESS =
  'tube/companyrules/management/PUT_VALIDATE_CORPORATION_PERMISSION_SUCCESS';
const PUT_VALIDATE_CORPORATION_PERMISSION_FAILURE =
  'tube/companyrules/management/PUT_VALIDATE_CORPORATION_PERMISSION_FAILURE';
const DELETE_MANAGEMENT_CATEGORY_REQUEST =
  'tube/companyrules/management/DELETE_MANAGEMENT_CATEGORY_REQUEST';
const DELETE_MANAGEMENT_CATEGORY_SUCCESS =
  'tube/companyrules/management/DELETE_MANAGEMENT_CATEGORY_SUCCESS';
const DELETE_MANAGEMENT_CATEGORY_FAILURE =
  'tube/companyrules/management/DELETE_MANAGEMENT_CATEGORY_FAILURE';
const FETCH_MANAGEMENT_RULES_REQUEST =
  'tube/companyrules/management/FETCH_MANAGEMENT_RULES_REQUEST';
const FETCH_MANAGEMENT_RULES_SUCCESS =
  'tube/companyrules/management/FETCH_MANAGEMENT_RULES_SUCCESS';
const FETCH_MANAGEMENT_RULES_FAILURE =
  'tube/companyrules/management/FETCH_MANAGEMENT_RULES_FAILURE';
const UPLOAD_MANAGEMENT_NEWSFILE_REQUEST =
  'tube/companyrules/management/UPLOAD_MANAGEMENT_NEWSFILE_REQUEST';
const UPLOAD_MANAGEMENT_NEWSFILE_SUCCESS =
  'tube/companyrules/management/UPLOAD_MANAGEMENT_NEWSFILE_SUCCESS';
const UPLOAD_MANAGEMENT_NEWSFILE_FAILURE =
  'tube/companyrules/management/UPLOAD_MANAGEMENT_NEWSFILE_FAILURE';

export default function reducer(
  state = {
    validateFailData: {},
    rulesList: [],
    rules: {},
    rulesListMeta: {},
    error: {},
    isLoading: false,
    isListLoading: false,
  },
  action
) {
  switch (action.type) {
    case FETCH_MANAGEMENT_TREEVIEWS_FAILURE: {
      return Object.assign({}, state, {
        error: action.error,
        isListLoading: false,
      });
    }
    case FETCH_MANAGEMENT_VIEW_FAILURE:
    case PUT_MANAGEMENT_CATEGORY_FAILURE:
    case PUT_VALIDATE_CORPORATION_PERMISSION_FAILURE: {
      return Object.assign({}, state, {
        error: action.error,
        isLoading: false,
      });
    }
    case FETCH_MANAGEMENT_TREEVIEWS_REQUEST: {
      return Object.assign({}, state, {
        isListLoading: true,
      });
    }
    case FETCH_MANAGEMENT_VIEW_REQUEST:
    case PUT_MANAGEMENT_CATEGORY_REQUEST:
    case PUT_VALIDATE_CORPORATION_PERMISSION_REQUEST: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }
    case FETCH_MANAGEMENT_TREEVIEWS_SUCCESS: {
      const list = action.response.data;
      const meta = buildPageMeta(action.response.meta);
      return Object.assign({}, state, {
        isListLoading: false,
        rulesList: list,
        rulesListMeta: meta,
      });
    }
    case FETCH_MANAGEMENT_VIEW_SUCCESS: {
      const data = action.response.data;
      return Object.assign({}, state, {
        isLoading: false,
        rules: data,
      });
    }
    case PUT_MANAGEMENT_CATEGORY_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        validateFailData: action.response.data,
      });
    }
    case PUT_VALIDATE_CORPORATION_PERMISSION_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
      });
    }
    default:
      return state;
  }
}

/* 列表樹狀資料查詢(管理畫面) */
export function fetchManagementTreeViews() {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/Management/TreeView`,
      method: 'GET',
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        FETCH_MANAGEMENT_TREEVIEWS_REQUEST,
        FETCH_MANAGEMENT_TREEVIEWS_SUCCESS,
        FETCH_MANAGEMENT_TREEVIEWS_FAILURE,
      ],
    },
  };
}

/* 分類單筆查詢(管理畫面) */
export function fetchManagementView(companyRegulationsCategoryId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Category/Management/${companyRegulationsCategoryId}`,
      method: 'GET',
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        FETCH_MANAGEMENT_VIEW_REQUEST,
        FETCH_MANAGEMENT_VIEW_SUCCESS,
        FETCH_MANAGEMENT_VIEW_FAILURE,
      ],
    },
  };
}
/* 規章單筆查詢 */
export function fetchManagementRules(companyRegulationsId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/Management/${companyRegulationsId}`,
      method: 'GET',
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        FETCH_MANAGEMENT_RULES_REQUEST,
        FETCH_MANAGEMENT_RULES_SUCCESS,
        FETCH_MANAGEMENT_RULES_FAILURE,
      ],
    },
  };
}

/* 新增規章 */
export function postManagementRules(data) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/Management/`,
      method: 'POST',
      params: data,
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        POST_MANAGEMENT_RULES_REQUEST,
        POST_MANAGEMENT_RULES_SUCCESS,
        POST_MANAGEMENT_RULES_FAILURE,
      ],
    },
  };
}

/* 修改規章 */
export function putManagementRules(data, companyRegulationsId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/Management/${companyRegulationsId}`,
      method: 'PUT',
      params: data,
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        PUT_MANAGEMENT_RULES_REQUEST,
        PUT_MANAGEMENT_RULES_SUCCESS,
        PUT_MANAGEMENT_RULES_FAILURE,
      ],
    },
  };
}

/* 刪除規章 */
export function deleteManagementRules(companyRegulationsId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/Management/${companyRegulationsId}`,
      method: 'DELETE',
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        DELETE_MANAGEMENT_RULES_REQUEST,
        DELETE_MANAGEMENT_RULES_SUCCESS,
        DELETE_MANAGEMENT_RULES_FAILURE,
      ],
    },
  };
}
/* 新增類別 */
export function postManagementCategory(data) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Category/Management/`,
      method: 'POST',
      params: data,
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        POST_MANAGEMENT_CATEGORY_REQUEST,
        POST_MANAGEMENT_CATEGORY_SUCCESS,
        POST_MANAGEMENT_CATEGORY_FAILURE,
      ],
    },
  };
}

/* 檢核修改類別前的公司別權限 */
export function putValidateCorporationsPermission(companyRegulationsId, data) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Category/Management/Valid/${companyRegulationsId}`,
      method: 'PUT',
      params: data,
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        PUT_VALIDATE_CORPORATION_PERMISSION_REQUEST,
        PUT_VALIDATE_CORPORATION_PERMISSION_SUCCESS,
        PUT_VALIDATE_CORPORATION_PERMISSION_FAILURE,
      ],
    },
  };
}

/* 修改類別 */
export function putManagementCategory(companyRegulationsId, data) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Category/Management/${companyRegulationsId}`,
      method: 'PUT',
      params: data,
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        PUT_MANAGEMENT_CATEGORY_REQUEST,
        PUT_MANAGEMENT_CATEGORY_SUCCESS,
        PUT_MANAGEMENT_CATEGORY_FAILURE,
      ],
    },
  };
}

/* 刪除類別 */
export function deleteManagementCategory(companyRegulationsId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Category/Management/${companyRegulationsId}`,
      method: 'DELETE',
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        DELETE_MANAGEMENT_CATEGORY_REQUEST,
        DELETE_MANAGEMENT_CATEGORY_SUCCESS,
        DELETE_MANAGEMENT_CATEGORY_FAILURE,
      ],
    },
  };
}

/* 刪除檔案 */
export function deleteManagementNewsFile(companyRegulationsId, attachmentId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/Management/${companyRegulationsId}/Attachment/${attachmentId}`,
      method: 'DELETE',
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        DELETE_MANAGEMENT_NEWSFILE_REQUEST,
        DELETE_MANAGEMENT_NEWSFILE_SUCCESS,
        DELETE_MANAGEMENT_NEWSFILE_FAILURE,
      ],
    },
  };
}
/* 上傳附件 */
export function uploadManagementNewsFile(companyRegulationsId, formData) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/Management/${companyRegulationsId}/Attachment`,
      method: 'POST',
      headers: {
        functionCode: 'CompanyRuleHR',
        actionCode: 'Manage',
      },
      types: [
        UPLOAD_MANAGEMENT_NEWSFILE_REQUEST,
        UPLOAD_MANAGEMENT_NEWSFILE_SUCCESS,
        UPLOAD_MANAGEMENT_NEWSFILE_FAILURE,
      ],
      contentType: CONTENT_TYPE.FORM,
      params: formData,
    },
  };
}
/* 下載附件 */
export function downloadAnnouncementFile(apiUrl) {
  const fetchOptions = {
    mode: 'cors',
    method: 'GET',
    headers: {},
  };
  let downloadUrl = apiUrl.split('api/')[1];
  fetchOptions.headers['Content-Type'] = 'application/json';
  downloadUrl = `${NEWTUBE_API_SERVER}${downloadUrl}`;
  return fetchData(downloadUrl, fetchOptions);
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/CompanyRules/screens/RegulationManagement/reducers/index.js
 **/